import { HeroBanner, HomeMainContent } from '../../components';

const Home = () => {
  return (
    <>
      <HeroBanner />

      <HomeMainContent />
    </>
  );
}

export default Home;